// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"1dabe284","788":"62cafbfb"}[chunkId] + ".chunk.js";
};